export const pollPreviewStatusSelector = state => state.pollPreviewStatus;
export const updateDisablePublishSelector = state => state.updateDisablePublish;
export const hasFailedPollingDraftStatusSelector = state => state.previewDraft.hasFailedPolling;
export const buildStatusPollingInProgressSelector = state => state.previewDraft.isStatusPollingInProgress;
export const previewLiveStatusPollingInProgressSelector = state => state.previewLive.isStatusPollingInProgress;
export const disablePublishSelector = state => state.previewDraft.disablePublish;
export const previewDraftBuildResponseSelector = state => state.previewDraft.buildResponse;
export const previewLiveBuildResponseSelector = state => state.previewLive.buildResponse;
export const clearPreviewStateSelector = state => state.clearPreviewState;
export const setBuildDraftResponseSelector = state => state.setBuildDraftResponse;
